var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6361_29696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.970703,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6361_29696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.9707H7V8.9707H5.5V12.9707ZM9.25 12.9707H10.75V8.9707H9.25V12.9707ZM13 12.9707H14.5V8.9707H13V12.9707ZM3.5 14.9707H16.5V6.9707H3.5V14.9707ZM4.5 17.9707V16.4707H3.5C3.0875 16.4707 2.73438 16.3238 2.44063 16.0301C2.14688 15.7363 2 15.3832 2 14.9707V6.9707C2 6.5582 2.14688 6.20508 2.44063 5.91133C2.73438 5.61758 3.0875 5.4707 3.5 5.4707H4.5V3.9707H6V5.4707H9.25V3.9707H10.75V5.4707H13.5V3.9707H15V5.4707H16.5C16.9125 5.4707 17.2656 5.61758 17.5594 5.91133C17.8531 6.20508 18 6.5582 18 6.9707V14.9707C18 15.3832 17.8531 15.7363 17.5594 16.0301C17.2656 16.3238 16.9125 16.4707 16.5 16.4707H15V17.9707H13.5V16.4707H10.75V17.9707H9.25V16.4707H6V17.9707H4.5Z",
    fill: "black",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRam);
export default __webpack_public_path__ + "static/media/ram.573da73a4294cde242fa860e5fa0cbbe.svg";
export { ForwardRef as ReactComponent };